import Playground from "./3D/Playground";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Playground />
    </div>
  );
}
